import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom"; // Para obtener el ID de la URL
import apiClient from '../../acciones/apiClient';
import "./proyectos.css";
import { jwtDecode } from 'jwt-decode';

import { NavBar } from "../../componentes/navbar";

import { CardPeque } from "../../componentes/cardPeque/carPeque";
import { ImgCabecera } from '../../componentes/imgCabecera/imgCabe';

export const InfoProyecto = () => {
    const [activeTab, setActiveTab] = useState("informacion");
    const [projectData, setProjectData] = useState(null); // Estado para almacenar los datos del proyecto
    const { id } = useParams(); // Captura el ID del proyecto desde la URL
    const [temporadas, setTemporadas] = useState([]); // Lista de temporadas
    const [capitulos, setCapitulos] = useState([]); // Lista de capítulos
    const [selectedTemporada, setSelectedTemporada] = useState(null); // Temporada seleccionada
    const [comentarios, setComentarios] = useState([]); // Lista de comentarios
    const [nuevoComentario, setNuevoComentario] = useState(""); // Nuevo comentario del usuario
    const [esFavorito, setEsFavorito] = useState(false);


    const [showAgeConfirmation, setShowAgeConfirmation] = useState(false); // Controla el aviso de +18
    const history = useHistory(); // Para redirigir al usuario

    useEffect(() => {
        console.log("Capítulos almacenados en el estado:", capitulos); // Log para depuración
    }, [capitulos]);


    // Fetch de los datos del proyecto
    // Fetch de los datos del proyecto
    useEffect(() => {
        const fetchProjectData = async () => {
            try {
                const response = await apiClient.get(`/proyectos/${id}`);
                setProjectData(response.data);

                // Si el proyecto es +18, mostrar aviso
                if (response.data.mayores_18) {
                    setShowAgeConfirmation(true);
                }
            } catch (error) {
                console.error("Error al cargar los datos del proyecto:", error);
            }
        };

        fetchProjectData();
    }, [id]);

    useEffect(() => {
        const verificarFavorito = async () => {
            try {
                const user_id = jwtDecode(localStorage.getItem('token')).id;
                const response = await apiClient.get(`/usuarios/favoritos/verificar`, {
                    params: {
                        user_id,
                        proyecto_id: id, // ID del proyecto actual
                    },
                });
                setEsFavorito(response.data.esFavorito);
            } catch (error) {
                console.error("Error al verificar si es favorito:", error);
            }
        };

        verificarFavorito();
    }, [id]);

    // Fetch de las temporadas
    useEffect(() => {
        const fetchTemporadas = async () => {
            try {
                const response = await apiClient.get(`/temporadas/${id}`);
                setTemporadas(response.data);
                if (response.data.length > 0) {
                    setSelectedTemporada(response.data[0].temporada_id);
                }
            } catch (error) {
                console.error("Error al cargar las temporadas:", error);
            }
        };

        fetchTemporadas();
    }, [id]);

    // Fetch de los capítulos según la temporada seleccionada
    // Fetch de los capítulos según la temporada seleccionada
    useEffect(() => {
        const fetchCapitulos = async () => {
            if (!selectedTemporada) {
                setCapitulos([]);
                return;
            }

            try {
                const response = await apiClient.get(
                    `/capitulos/temporada/${selectedTemporada}`
                );
                console.log("Capítulos recibidos en el frontend:", response.data);
                setCapitulos(response.data);
            } catch (error) {
                console.error("Error al cargar los capítulos:", error);
                setCapitulos([]);
            }
        };

        fetchCapitulos();
    }, [selectedTemporada]);


    // Fetch de los comentarios
    useEffect(() => {
        const fetchComentarios = async () => {
            try {
                const response = await apiClient.get(`/proyectos/${id}/comentarios`);
                setComentarios(response.data);
            } catch (error) {
                console.error("Error al cargar los comentarios:", error);
            }
        };

        fetchComentarios();
    }, [id]);

    // Enviar nuevo comentario
    const handleEnviarComentario = async () => {
        if (!nuevoComentario.trim()) return; // Evita comentarios vacíos
        try {
            const usuario_id = jwtDecode(localStorage.getItem('token')).id; // Reemplaza esto con el ID del usuario autenticado
            await apiClient.post(`/proyectos/${id}/comentarios`, {
                comentario: nuevoComentario,
                usuario_id,
                proyecto_id: id,
            });
            setComentarios((prev) => [
                { usuario: "Tú", comentario: nuevoComentario }, // Agrega el nuevo comentario a la lista localmente
                ...prev,
            ]);
            setNuevoComentario(""); // Limpia el textarea
        } catch (error) {
            console.error("Error al enviar el comentario:", error);
        }
    };


    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const handleTemporadaChange = (event) => {
        const temporadaId = event.target.value;
        setSelectedTemporada(temporadaId); // Actualiza la temporada seleccionada
        setCapitulos([]); // Limpia los capítulos mientras se cargan los nuevos
    };

    // Manejo de confirmación de edad
    const handleAgeConfirmation = () => {
        setShowAgeConfirmation(false); // Oculta el aviso y muestra el contenido
    };

    const handleExit = () => {
        history.push("/"); // Redirige al usuario al inicio
    };

    if (showAgeConfirmation) {
        // Mostrar aviso si el proyecto es +18 y el usuario no ha confirmado
        return (
            <div className="age-confirmation-container">
                <h2>Este proyecto contiene contenido para mayores de 18 años.</h2>
                <p>Por favor, confirma que tienes más de 18 años para continuar.</p>
                <div className="age-confirmation-buttons">
                    <button onClick={handleAgeConfirmation}>Tengo más de 18 años</button>
                    <button onClick={handleExit}>Salir</button>
                </div>
            </div>
        );
    }


    return (
        <div className="info-proyecto-container">
            <ImgCabecera />
            <NavBar />

            <div className="portada-container">
                <img
                    src={projectData?.portada}
                    alt="Portada"
                    className="portada-central"
                />
            </div>

            <div className="titulo-container">
                <h1 className="titulo-proyecto">
                    {projectData?.titulo || "Cargando título..."}
                </h1>
                <h3 className="nombre-alternativo">
                    {projectData?.nombre_alternativo || "Cargando nombre alternativo..."}
                </h3>
            </div>



            <div
                className="heart-containerInfoPro"
                title="Like"
                onClick={async () => {
                    try {
                        const user_id = jwtDecode(localStorage.getItem('token')).id; // Reemplaza con el ID del usuario autenticado
                        if (!esFavorito) {
                            // Agregar a favoritos
                            await apiClient.post('/usuarios/favoritos', {
                                user_id,
                                proyecto_id: id,
                            });
                            setEsFavorito(true); // Actualiza el estado local
                        } else {
                            // Eliminar de favoritos (si implementas esta funcionalidad)
                            alert('Funcionalidad para eliminar no implementada aún');
                        }
                    } catch (error) {
                        console.error("Error al cambiar favorito:", error);
                    }
                }}
            >
                <input type="checkbox" className="checkbox" id="Give-It-An-Id" checked={esFavorito} readOnly />
                <div className="svg-container">
                    <svg viewBox="0 0 24 24" className="svg-outline" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Zm-3.585,18.4a2.973,2.973,0,0,1-3.83,0C4.947,16.006,2,11.87,2,8.967a4.8,4.8,0,0,1,4.5-5.05A4.8,4.8,0,0,1,11,8.967a1,1,0,0,0,2,0,4.8,4.8,0,0,1,4.5-5.05A4.8,4.8,0,0,1,22,8.967C22,11.87,19.053,16.006,13.915,20.313Z"></path>
                    </svg>
                    <svg viewBox="0 0 24 24" className="svg-filled" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"></path>
                    </svg>
                </div>
            </div>







            <div className="tabs-container">
                <button
                    className={`tab-button ${activeTab === "capitulos" ? "active" : ""}`}
                    onClick={() => handleTabChange("capitulos")}
                >
                    Capítulos
                </button>
                <button
                    className={`tab-button ${activeTab === "informacion" ? "active" : ""}`}
                    onClick={() => handleTabChange("informacion")}
                >
                    Información
                </button>
                <button
                    className={`tab-button ${activeTab === "comentarios" ? "active" : ""}`}
                    onClick={() => handleTabChange("comentarios")}
                >
                    Comentarios
                </button>
            </div>

            <div className="tab-content">
                {activeTab === "capitulos" && (
                    <div className="capitulos-tab">
                        <div className="temporada-selector">
                            <select
                                className="form-select"
                                value={selectedTemporada}
                                onChange={handleTemporadaChange}
                            >
                                {temporadas.map((temporada) => (
                                    <option key={temporada.temporada_id} value={temporada.temporada_id}>
                                        {temporada.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="cardPequeContenedor">
                            {capitulos.length > 0 ? (
                                capitulos.map((capitulo) => {
                                    console.log("Datos pasados a CardPeque:", capitulo);
                                    return (
                                        <a href={`/capitulo/${capitulo.capitulo_id}`} key={capitulo.capitulo_id}>
                                            <CardPeque
                                                title={capitulo.titulo}
                                            />
                                        </a>
                                    );
                                })
                            ) : (
                                <p>No hay capítulos disponibles para esta temporada.</p>
                            )}
                        </div>

                        <br />
                        <br />
                    </div>
                )}
                {activeTab === "informacion" && (
                    <div className="informacion-tab">
                        <h3>Información del Proyecto</h3>
                        <div className="informacion-detalles">
                            <p><strong>Descripción:</strong></p>
                            <p className="descripcionProyecto">{projectData?.descripcion || "No hay descripción disponible."}</p>
                            <p><strong>Familia:</strong></p>
                            <p>{projectData?.usuario || "PS"}</p>
                            <p><strong>Autor:</strong></p>
                            <p>{projectData?.autor}</p>
                            <p><strong>Géneros:</strong></p>
                            <ul>
                                {projectData?.genero?.length > 0 ? (
                                    projectData.genero.map((genero, index) => (
                                        <li key={index}>{genero}</li>
                                    ))
                                ) : (
                                    <li>No hay géneros disponibles.</li>
                                )}
                            </ul>
                            <br />
                        </div>
                    </div>
                )}


                {activeTab === "comentarios" && (
                    <div className="comentarios-tabProyecto">
                        <h3>Comentarios</h3>
                        <div className="comentarios-containerProyecto">
                            {/* Barra para escribir comentarios */}
                            <div className="comentarios-input-container">
                                <textarea
                                    className="comentarios-textarea"
                                    placeholder="Escribe tu comentario aquí..."
                                    value={nuevoComentario}
                                    onChange={(e) => setNuevoComentario(e.target.value)}
                                />
                                <button
                                    className="comentarios-boton-enviar"
                                    onClick={handleEnviarComentario}
                                >
                                    Enviar
                                </button>
                            </div>

                            {/* Lista de comentarios */}
                            <div className="comentarios-lista">
                                {comentarios.length > 0 ? (
                                    comentarios.map((comentario, index) => (
                                        <div className="comentario-item" key={index}>
                                            <p className="comentario-usuario">
                                                {comentario.usuario.nombre_usuario}:
                                            </p>
                                            <p className="comentario-texto">{comentario.comentario}</p>
                                        </div>
                                    ))
                                ) : (
                                    <p className="comentarios-vacio">No hay comentarios aún. Sé el primero en comentar.</p>
                                )}
                            </div>
                            <br /><br />
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};